import { useEffect, useState } from 'react';
import { crudOperations, eventSourceType } from '../../constants';

const useRefineFilter = ({
  handleRefineFilterSave, customFilter,
}) => {
  const [crudOp, setCrudOp] = useState(crudOperations);
  const [eventSource, setEventSource] = useState(eventSourceType);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if (customFilter.custom_entity_id) {
      const valueFromFilter = customFilter.event_source_type?.[0]; // take first value if present
      let updatedList = eventSourceType;
      if (valueFromFilter) {
        updatedList = eventSourceType.map((o) => ({ ...o, selected: o.value === valueFromFilter }));
      }

      const crudOpData = crudOperations.map((obj) => {
        if (customFilter.operation_type && customFilter.operation_type.includes(obj.value)) {
          obj.selected = true;
        } else {
          obj.selected = false;
        }
        return obj;
      });

      setCrudOp(crudOpData);
      setEventSource(updatedList);
    }
  }, [customFilter.custom_entity_id]);

  const handleDisabled = () => {
    const isCrudFlag = crudOp.some((obj) => obj.selected);
    const isOtherFlag = eventSource.some((obj) => obj.selected);
    setDisabled(!(isCrudFlag || isOtherFlag));
  };

  const handleOnClickEventSource = (value) => {
    const updateEventSource = eventSource.map((obj) => ({
      ...obj,
      selected: obj.value === value, // only one selected
    }));
    setEventSource(updateEventSource);
    handleDisabled();
  };

  const handleOnClickCrudOp = (value) => {
    const updateCrudOp = crudOp.map((obj) => {
      if (obj.value === value) {
        obj.selected = !obj.selected;
      }
      return obj;
    });
    setCrudOp(updateCrudOp);
    handleDisabled();
  };

  const handleSelectAllOp = (type) => {
    if (type === 'crud') {
      const updateCrudOp = crudOp.map((obj) => ({ ...obj, selected: true }));
      setCrudOp(updateCrudOp);
    }
    handleDisabled();
  };

  const handleUnSelectAllOp = (type) => {
    if (type === 'crud') {
      const updateCrudOp = crudOperations.map((obj) => ({ ...obj, selected: false }));
      setCrudOp(updateCrudOp);
    }
    handleDisabled();
  };

  const handleSave = () => {
    const crudList = crudOp.filter((obj) => obj.selected).map((obj) => obj.value);
    const selectedEventSource = eventSource.find((obj) => obj.selected);
    const eventSourceList = selectedEventSource?.value === '-all-' ? [] : [selectedEventSource.value];
    handleRefineFilterSave(customFilter, crudList, eventSourceList);
  };

  return {
    crudOp,
    eventSource,
    disabled,
    handleOnClickEventSource,
    handleOnClickCrudOp,
    handleSelectAllOp,
    handleUnSelectAllOp,
    handleSave,
  };
};

export default useRefineFilter;
